<template>
  <div>
<!--    <div class="modal-overlay" id="modal-overlay"></div>-->
    <div class="modal" id="modal">

      <h2 class="glitch">DAS ERGEBNIS</h2>

      <div class="results">
        <div class="headline">
          Übersicht
        </div>
        <div class="left">

          <div class="diag">

            <svg viewBox="0 0 290 290">

              <g transform="translate(-0.0, 0.0)">
                <path :fill="segColor(1)"
                      d="M145,4.54747351e-13 C199.112775,4.54747351e-13 246.302291,29.6419924 271.216977,73.5744043 L250.985364,85.0232841 C229.930043,47.9131203 190.260846,23 145,23 L145,4.54747351e-13 Z"></path>
                <path :fill="segColor(2)"
                      d="M267,146 C267,123.377326 260.957288,102.221091 250.427438,84.0503003 L270.552373,72.4149994 C282.920137,93.7617667 290,118.554088 290,145 C290,171.925828 282.660847,197.137506 269.873843,218.743731 L250.422451,207.256405 C260.95538,189.231835 267,168.294263 267,146 Z"></path>
                <path :fill="segColor(3)"
                      d="M144.021,289.992 L144.168773,267.997279 L145,268 L145,268 C190.264028,268 229.935622,243.083376 250.989805,206.275102 L270.551791,217.586005 C245.46839,260.879171 198.634962,290 145,290 L144.021,289.992 Z"></path>
                <path :fill="segColor(4)"
                      d="M18.7832661,216.426024 L37.7217981,205.708759 C58.7622846,242.827561 98.8267299,268 145,268 L145,290 C90.8874009,290 43.6980151,260.3582 18.7832661,216.426024 Z"></path>
                <path :fill="segColor(5)"
                      d="M-1.13686838e-13,145 C-1.13686838e-13,118.0736 7.33946427,92.8614242 20.1269713,71.2548935 L39.4323071,82.6560003 C28.3571324,101.135197 22,122.796227 22,146 C22,168.062017 27.919339,188.795462 38.285295,206.692156 L19.4470584,217.584019 C7.07964645,196.237473 -1.13686838e-13,171.445507 -1.13686838e-13,145 Z"></path>
                <path :fill="segColor(6)"
                      d="M145,4.54747351e-12 L145,23 C99.6409901,23 60.1772481,47.2924417 38.8526157,83.6334833 L19.447627,72.4149994 C44.5308859,29.1212796 91.3646233,4.54747351e-12 145,4.54747351e-12 Z"></path>
              </g>

            </svg>

            <div class="text">
              Sie haben<br/>
              <span>{{ score() }}</span>
              Punkte erreicht.
            </div>

          </div>

          <div class="leftLegend">
            <div>
              <img src="../assets/icons_UI_icon_check.svg" alt=""/>
              <span>{{ correct() }}</span><br/>
              richtig
            </div>
            <div>
              <img src="../assets/icons_UI_icon_wrong.svg" alt=""/>
              <span>{{ wrong() }}</span><br/>
              falsch
            </div>
            <div>
              <img src="../assets/icons_UI_icon_missed.svg" alt=""/>
              <span>{{ undiscovered() }}</span><br/>
              unerkannt
            </div>

          </div>

        </div>

        <div class="right">

          <div class="right1">

            <h4>
              <img src="../assets/icons_illu_auto_hoehe.svg" alt=""/>
              Perspektive Auto
            </h4>

            <div v-if="res('car', 'q1')" @click="showDetails('q1')">
              <img :src="resIcon('q1')" alt=""/>
              <a href="#">Überholen und Abbiegen &gt;</a>
            </div>

            <div v-if="res('car', 'q2')" @click="showDetails('q2')">
              <img :src="resIcon('q2')" alt=""/>
              <a href="#">Zebrastreifen &gt;</a>
            </div>

            <div v-if="res('car', 'q3')" @click="showDetails('q3')">
              <img :src="resIcon('q3')" alt=""/>
              <a href="#">Radweg &gt;</a>
            </div>

            <div v-if="res('car', 'q4')" @click="showDetails('q4')">
              <img :src="resIcon('q4')" alt=""/>
              <a href="#">Ablenkung &gt;</a>
            </div>

            <div v-if="res('car', 'q5')" @click="showDetails('q5')">
              <img :src="resIcon('q5')" alt=""/>
              <a href="#">Rechtsabbiegen &gt;</a>
            </div>

            <div v-if="res('car', 'q6')" @click="showDetails('q6')">
              <img :src="resIcon('q6')" alt=""/>
              <a href="#">Dooring &gt;</a>
            </div>

          </div>

          <div class="right2">

            <h4>
              <img src="../assets/icons_illu_fahrrad.svg" alt=""/>
              Perspektive Fahrrad
            </h4>

            <div v-if="res('bike', 'q1')" @click="showDetails('q1')">
              <img :src="resIcon('q1')" alt=""/>
              <a href="#">Überholen und Abbiegen &gt;</a>
            </div>

            <div v-if="res('bike', 'q2')" @click="showDetails('q2')">
              <img :src="resIcon('q2')" alt=""/>
              <a href="#">Zebrastreifen &gt;</a>
            </div>

            <div v-if="res('bike', 'q3')" @click="showDetails('q3')">
              <img :src="resIcon('q3')" alt=""/>
              <a href="#">Radweg &gt;</a>
            </div>

            <div v-if="res('bike', 'q4')" @click="showDetails('q4')">
              <img :src="resIcon('q4')" alt=""/>
              <a href="#">Ablenkung &gt;</a>
            </div>

            <div v-if="res('bike', 'q5')" @click="showDetails('q5')">
              <img :src="resIcon('q5')" alt=""/>
              <a href="#">Rechtsabbiegen &gt;</a>
            </div>

            <div v-if="res('bike', 'q6')" @click="showDetails('q6')">
              <img :src="resIcon('q6')" alt=""/>
              <a href="#">Dooring &gt;</a>
            </div>

          </div>

        </div>

      </div>

      <div class="result-controls">
        <button
            class="default leftControlButton"
            @click.prevent.stop="restart"
        >
          <span>Erneut spielen</span>
          <img class="rightIcon"
               src="../assets/icons_UI_icon_again.svg"
               alt="" />
        </button>

        <button
            class="green glow"
            @click.prevent.stop="showDetails('q1')"
        >
          <span>Detailauswertung</span>
          <img
              class="rightIcon hoverNo"
              src="../assets/icons_UI_chevron_right_black.svg"
              alt="" />
          <img
              class="rightIcon hoverYes"
              src="../assets/icons_UI_chevron_right.svg"
              alt="" />
        </button>
      </div>

    </div>
    <CategoryContainer ref="categoryContainer" :result="result" />
  </div>
</template>

<script>

import CategoryContainer from "./ResultsModal/CategoryContainer";

let questions = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'];

export default {
  name: "ResultsModal",
  props: {
      result: {
          required: true,
          type: Object
      }
  },
  components: {CategoryContainer},
  computed: {},
  data() {
    return {

    }
  },
  mounted() {

    console.log('RESULT', this.result);

    // this.result = {
    //   q1: {perspective: 'car', missed: false, correct: true},
    //   q2: {perspective: 'car', missed: false, correct: true},
    //   q3: {perspective: 'car', missed: false, correct: true},
    //   q4: {perspective: 'bike', missed: false, correct: false},
    //   q5: {perspective: 'bike', missed: false, correct: false},
    //   q6: {perspective: 'bike', missed: true, correct: false},
    // }
  },

  methods: {
    showDetails(id) {
        this.$refs.categoryContainer.showSlide(id);
    },

    restart() {
      this.$router.push('/');
    },

    segColor(nr) {
      let c = this.correct();
      if (nr <= c) {
        return '#b9d400';
      } else {
        let w = this.wrong();
        if (nr <= c + w) {
          return '#a6cfb7';
        } else {
          let u = this.undiscovered();
          if (nr <= c + w + u) {
            return '#666666';
          }
        }
      }
      return '#000';
    },

    resIcon(nr) {
      let r = 'missed';
      if (this.result[nr]) {
        if (this.result[nr].correct) {
          r = 'check';
        } else if (!this.result[nr].missed) {
          r = 'wrong';
        }
      }
      return require('../assets/icons_UI_icon_' + r + '.svg');
    },
    res(perspective, nr) {
      return this.result[nr]
          ? this.result[nr].perspective === perspective
          : false;
    },

    score() {
      return (this.correct() + (0.5 * this.wrong())) + ' / 6';
    },

    correct() {
      let a = 0;
      let res = this.result;
      questions.forEach((nr) => {
        if (res[nr] && res[nr].correct) {
          a++;
        }
      });
      return a;
    },
    undiscovered() {
      let a = 0;
      let res = this.result;
      questions.forEach((nr) => {
        if (res[nr] && res[nr].missed) {
          a++;
        }
      });
      return a;
    },
    wrong() {
      let a = 0;
      let res = this.result;
      questions.forEach((nr) => {
        if (res[nr] && !res[nr].correct && !res[nr].missed) {
          a++;
        }
      });
      return a;
    }
  }
}
</script>

<style lang="scss" scoped>

$vhUnit: 9;
$vwUnit: 16;
$vhUnitMobile: 3.75;
$vwUnitMobile: 6.66;

@function scaleVh($size) {
  @return #{($size/$vhUnit)}vh;
}
@function scaleVw($size) {
  @return #{($size/$vwUnit)}vw;
}
@function scaleMobileVh($size) {
  @return #{($size/$vhUnitMobile)}vh;
}
@function scaleMobileVw($size) {
  @return #{($size/$vwUnitMobile)}vw;
}

.results {
  position: absolute;
  background: rgb(38, 38, 38);
}

h4 {
  margin: 0;
  padding: 0;
}

.left {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.diag {
  position: relative;
}

.diag svg {
  width: 100%;
  height: 100%;
}

.diag .text {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
}

.leftLegend {
  display: flex;
  align-items: baseline;
}

.leftLegend div {
  flex: 1;
  text-align: center;
}

.right {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.right div a {
  color: #FFF;
  text-decoration: none;
}

.right div div:last-child {
  margin-bottom: 0;
}

.right div div {
  display: flex;
  align-items: center;
}

h4 {
  display: flex;
  align-items: center;
}

.text span {
  font-weight: bold;
}

.mobile .headline {
  display: none;
}

.headline {
  position: absolute;
  font-weight: bold;
}

.result-controls {
  position: absolute;
  display: flex;
  .leftControlButton {
    margin-right: auto;
  }
}

@media(min-aspect-ratio: 16/9) {

  .result-controls {
    top: scaleVh(128 + 549 + 50);
    left: scaleVh(425 - 184);
    width: scaleVh(750);
  }

  .text {
    font-size: scaleVh(20);
  }
  .text span {
    font-size: scaleVh(40);
    line-height: scaleVh(70);
  }

  h2 {
    margin-top: scaleVh(39);
    font-size: scaleVh(40);
  }

  .right div div {
    margin-top: scaleVh(20);
  }

  .right div div img {
    height: scaleVh(20);
    margin-right: scaleVh(10);
  }

  .leftLegend div img {
    margin-right: scaleVh(10);
    height: scaleVh(24);
  }
  .leftLegend div span {
    font-size: scaleVh(32);
  }

  h4 img {
    width: scaleVh(30);
    margin-right: scaleVh(12);
  }

  .left {
    width: scaleVh(290);
    left: scaleVh(93);
    top: scaleVh(111);
    bottom: scaleVh(107);
  }
  .right {
    width: scaleVh(367 - 113);
    top: scaleVh(111);
    left: scaleVh(290 + 93 + 113);
    bottom: scaleVh(107);
  }
  .diag {
    width: scaleVh(290);
    height: scaleVh(290);
  }

  .leftLegend {
    margin-top: scaleVh(33);
  }
  .headline {
    top: scaleVh(40);
    left: scaleVh(321);
    font-size: scaleVh(25);
  }
  .results {
    top: scaleVh(128);
    left: scaleVh(425 - 184);
    width: scaleVh(750);
    height: scaleVh(549);
    font-size: scaleVh(14);
  }

  // mobile -----

  .mobile {
    .text {
      font-size: scaleMobileVh(12);
    }
    .text span {
      font-size: scaleMobileVh(24);
      line-height: scaleMobileVh(44);
    }
    h2 {
      margin-top: scaleMobileVh(17);
      font-size: scaleMobileVh(20);
    }
    .right div div {
      margin-top: scaleMobileVh(10);
    }
    .right div div img {
      height: scaleVh(30);
      margin-right: scaleMobileVh(10);
    }
    .leftLegend div img {
      margin-right: scaleMobileVh(4);
      height: scaleMobileVh(16);
    }
    .leftLegend div span {
      font-size: scaleMobileVh(18);
    }
    h4 {
      margin-bottom: scaleMobileVh(20);
    }
    h4 img {
      width: scaleMobileVh(21);
      margin-right: scaleMobileVh(12);
    }
    .left {
      width: scaleMobileVh(165);
      left: scaleMobileVh(33);
      top: scaleMobileVh(21);
      bottom: scaleMobileVh(16);
    }
    .right {
      display: flex;
      flex-direction: row;
      width: scaleMobileVh(564 - (165 + 33 + 34) - 37);
      top: scaleMobileVh(21);
      left: scaleMobileVh(165 + 33 + 34);
      bottom: scaleMobileVh(16);
    }
    .diag {
      width: scaleMobileVh(165);
      height: scaleMobileVh(165);
    }
    .results {
      top: scaleMobileVh(52);
      left: scaleMobileVh(52 - 34);
      width: scaleMobileVh(564);
      height: scaleMobileVh(255);
      font-size: scaleMobileVh(12);
    }
    .result-controls {
      left: scaleMobileVh(52 - 34);
      top: scaleMobileVh(52 + 255 + 18);
      width: scaleMobileVh(564);
      button {
        font-size: scaleMobileVh(14);
        font-weight: normal;
        padding: scaleMobileVh(8.5)
      }
      .glow,
      .rightControlButton {
        box-shadow: 0 0 scaleMobileVh(4) 0 rgb(185, 212, 0);
      }
    }

  }
}

@media(max-aspect-ratio: 16/9) {

  .result-controls {
    display: flex;
    align-content: space-between;
    top: scaleVw(128 + 549 + 50);
    left: scaleVw(425 - 184);
    width: scaleVw(750);
  }

  .text {
    font-size: scaleVw(20);
  }
  .text span {
    font-size: scaleVw(40);
    line-height: scaleVw(70);
  }

  h2 {
    margin-top: scaleVw(39);
    font-size: scaleVw(40);
  }

  .right div div {
    margin-top: scaleVw(20);
  }

  .right div div img {
    height: scaleVw(20);
    margin-right: scaleVw(10);
  }

  .leftLegend div img {
    margin-right: scaleVw(10);
    height: scaleVw(24);
  }
  .leftLegend div span {
    font-size: scaleVw(32);
  }

  h4 img {
    width: scaleVw(30);
    margin-right: scaleVw(12);
  }

  .left {
    width: scaleVw(290);
    left: scaleVw(93);
    top: scaleVw(111);
    bottom: scaleVw(107);
  }
  .right {
    width: scaleVw(367 - 113);
    top: scaleVw(111);
    left: scaleVw(290 + 93 + 113);
    bottom: scaleVw(107);
  }
  .diag {
    width: scaleVw(290);
    height: scaleVw(290);
  }

  .leftLegend {
    margin-top: scaleVw(33);
  }

  .headline {
    top: scaleVw(40);
    left: scaleVw(321);
    font-size: scaleVw(25);
  }

  .results {
    top: scaleVw(128);
    left: scaleVw(425 - 184);
    width: scaleVw(750);
    height: scaleVw(549);

    font-size: scaleVw(14);
  }

  .mobile {
    .text {
      font-size: scaleMobileVw(12);
    }
    .text span {
      font-size: scaleMobileVw(24);
      line-height: scaleMobileVw(44);
    }
    h2 {
      margin-top: scaleMobileVw(17);
      font-size: scaleMobileVw(20);
    }
    .right div div {
      margin-top: scaleMobileVw(10);
    }
    .right div div img {
      height: scaleVh(30);
      margin-right: scaleMobileVw(10);
    }
    .leftLegend div img {
      margin-right: scaleMobileVw(4);
      height: scaleMobileVw(16);
    }
    .leftLegend div span {
      font-size: scaleMobileVw(18);
    }
    h4 {
      margin-bottom: scaleMobileVw(20);
    }
    h4 img {
      width: scaleMobileVw(21);
      margin-right: scaleMobileVw(12);
    }
    .left {
      width: scaleMobileVw(165);
      left: scaleMobileVw(33);
      top: scaleMobileVw(21);
      bottom: scaleMobileVw(16);
    }
    .right {
      display: flex;
      flex-direction: row;
      width: scaleMobileVw(564 - (165 + 33 + 34) - 37);
      top: scaleMobileVw(21);
      left: scaleMobileVw(165 + 33 + 34);
      bottom: scaleMobileVw(16);
    }
    .diag {
      width: scaleMobileVw(165);
      height: scaleMobileVw(165);
    }
    .results {
      top: scaleMobileVw(52);
      left: scaleMobileVw(52 - 34);
      width: scaleMobileVw(564);
      height: scaleMobileVw(255);
      font-size: scaleMobileVw(12);
    }
    .result-controls {
      left: scaleMobileVw(52 - 34);
      top: scaleMobileVw(52 + 255 + 18);
      width: scaleMobileVw(564);
      button {
        font-size: scaleMobileVw(14);
        font-weight: normal;
        padding: scaleMobileVw(8.5)
      }
      .glow,
      .rightControlButton {
        box-shadow: 0 0 scaleMobileVw(4) 0 rgb(185, 212, 0);
      }
    }

  }
}


</style>